// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';
import { INSTAGRAM } from '@/lib/socialProfile';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const liveMentions = {
    title: 'chart.instagram.live_mentions',
    id: 'mentions_live',
    margin: { left: -20, right: 25, bottom: 50 },
    name: {
        date: 'date',
        value: 'chart.instagram.live_mentions_value'
    },
    color: {
        value: 'blue'
    },
    customDateFormatPrefix: '_24_noSeconds_date',
    datePickerDoesNotApply: true,
    social: INSTAGRAM,
    valueFormat: classicFormatMaxTwoDigits,
    tooltip: 'chart.instagram.live_mentions_tooltip',
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
